import { Link, useLocation } from 'react-router-dom';
import { FiEdit3, FiClock, FiDatabase, FiStar, FiSettings, FiLogOut } from 'react-icons/fi';

const Sidebar = () => {
  const location = useLocation();
  
  const menuItems = [
    { icon: FiEdit3, label: 'Agent C. Writer', path: '/' },
    { icon: FiClock, label: 'History', path: '/history' },
    { icon: FiDatabase, label: 'Train Models', path: '/train' },
    { icon: FiStar, label: 'Feature Requests', path: '/features' },
    { icon: FiSettings, label: 'Settings', path: '/settings' },
  ];

  return (
    <aside className="sidebar">
      <div className="space-y-2">
        {/* Logo */}
        <div className="px-4 py-3 text-primary-dark text-xl font-bold">
          LOGO
        </div>
        
        {/* Navigation Items */}
        <nav className="mt-8 space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-item ${isActive ? 'active' : ''}`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
      
      {/* Sign Out Button */}
      <button className="sidebar-item mt-auto">
        <FiLogOut className="w-5 h-5" />
        <span>Sign Out</span>
      </button>
    </aside>
  );
};

export default Sidebar; 